import PropTypes from 'prop-types';
import { toast } from "../../../../core/helpers/message-helper";
import FormModal from "../../../../core/ui/components/FormModal";
import { Col, Row } from "reactstrap";
import InputController from "../../../../core/ui/components/InputController";
import SelectController from "../../../../core/ui/components/SelectController";
import { useState } from "react";
import { useEffect } from "react";
import { selectLugaresPorSede } from "../../../Sedes/services/lugares-service";
import { mapToSelect } from "../../../../core/helpers/form-helper";
import { selectTemas } from "../../services/temas-services";
import { useForm } from "react-hook-form";
import { reservar } from "../../services/reservas-service";
import { useOutletContext } from "react-router-dom";

const REQUIRED_RULE = { required: "Este campo es requerido" };

const FormReservar = ({ modalState, onSave }) => {
    const { reserva } = modalState.data;
    const { sedeId, recursoId } = useOutletContext();
    const [selects, setSelects] = useState({ lugares: [], temas: [] });

    const defaultValues = {
        asunto: "",
        fecha: reserva.fecha ?? "",
        hora_fin: reserva.hora_fin ?? "",
        hora_inicio: reserva.hora_inicio ?? "",
        lugar_id: "",
        observacion: "",
        tema_id: "",
    };

    const form = useForm({ defaultValues });
    useEffect(() => form.reset(defaultValues), [reserva]);

    const onCreateReserva = async (reserva) => {
        reserva.lugar_id = reserva.lugar_id.value;
        reserva.tema_id = reserva.tema_id.value;
        reserva.recurso_id = recursoId;
        const resp = await reservar(reserva);

        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        modalState.close()
        onSave(resp.data);
    };

    useEffect(async () => {
        try {
            const selects = await Promise.all([
                selectLugaresPorSede(sedeId),
                selectTemas(),
            ]);
            const lugares = selects[0].data.map((lugar) =>
                mapToSelect(lugar.id, lugar.nombre)
            );

            const temas = selects[1].data.map((tema) =>
                mapToSelect(tema.id, tema.nombre)
            );

            setSelects({ lugares, temas });
        } catch (error) {
            return toast.error(
                "Ha ocurrido un error al obtener los datos de creación de reservas"
            );
        }
    }, []);

    return (
        <FormModal
            size="lg"
            form={form}
            id="formConfiguracion"
            onSubmit={onCreateReserva}
            isOpen={modalState.show}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <Col sm={4}>
                    <InputController
                        name="asunto"
                        label="Asunto"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Asunto"
                        rules={REQUIRED_RULE}
                    />
                </Col>
                <Col sm={4}>
                    <SelectController
                        errors={form.formState.errors}
                        control={form.control}
                        name="tema_id"
                        label="Tema"
                        rules={REQUIRED_RULE}
                        options={selects.temas}
                    />
                </Col>
                <Col sm={4}>
                    <SelectController
                        errors={form.formState.errors}
                        control={form.control}
                        name="lugar_id"
                        label="Lugar"
                        rules={REQUIRED_RULE}
                        options={selects.lugares}
                    />
                </Col>
                <Col sm={4}>
                    <InputController
                        name="fecha"
                        label="Fecha"
                        errors={form.formState.errors}
                        readOnly={true}
                        control={form.control}
                        placeholder="Fecha"
                        rules={REQUIRED_RULE}
                    />
                </Col>
                <Col sm={4}>
                    <InputController
                        errors={form.formState.errors}
                        readOnly={true}
                        control={form.control}
                        name="hora_inicio"
                        label="Hora Inicio"
                        rules={REQUIRED_RULE}
                        placeholder="Hora Inicio"
                    />
                </Col>
                <Col sm={4}>
                    <InputController
                        errors={form.formState.errors}
                        readOnly={true}
                        name="hora_fin"
                        label="Hora Fin"
                        control={form.control}
                        rules={REQUIRED_RULE}
                        placeholder="Hora Fin"
                    />
                </Col>
                <Col sm={12}>
                    <InputController
                        type="textarea"
                        errors={form.formState.errors}
                        name="observacion"
                        label="Observación"
                        control={form.control}
                        rules={REQUIRED_RULE}
                        placeholder="Observación"
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormReservar.propTypes = {
    modalState: PropTypes.object,
    onSave: PropTypes.func
}

export default FormReservar;
